export function getLiterals(t: any) {
  return {
    header: { maintext: t('confirmMail.header.maintext'), buttonLeft: t('confirmMail.header.buttonLeft'), buttonRight: t('confirmMail.header.buttonRight') },
    title: t('confirmMail.title'),
    desc1: t('confirmMail.desc1'),
    desc2: t('confirmMail.desc2'),
    confirmmail1:
      t('confirmMail.confirmmail1'),
    confirmmail2: t('confirmMail.confirmmail2'),
    buttonmail: {
      openYourMail: t("confirmMail.buttonmail.openYourMail"),
      verifyYourAccount: t("confirmMail.buttonmail.verifyYourAccount")
    },
    verificationCodeText: t('confirmMail.verificationCodeText')
  };
}


export function getPRecoverPasswordEmail(t: any) {
  return {
    title: t('getPRecoverPasswordEmail.title'),
    desc:  t('getPRecoverPasswordEmail.desc'),
    input: { maintext:  t('getPRecoverPasswordEmail.input.maintext'), },
    subinputtext: {
      maintext: t('getPRecoverPasswordEmail.subinputtext.maintext'),
      linktext: t('getPRecoverPasswordEmail.subinputtext.linktext'),
    },
    button: t('getPRecoverPasswordEmail.button'),
    messagesError: {
      invalidField: { maintext: t('getPRecoverPasswordEmail.messagesError.invalidField.maintext'), },
    }
}
}


export function getPRecoverPasswordIdLiterals(t: any) {
return{
  title:t('getPRecoverPasswordIdLiterals.title'),
  desc: t('getPRecoverPasswordIdLiterals.desc'),
  componenttitle: t('getPRecoverPasswordIdLiterals.componenttitle'),
  componentdesc:  t('getPRecoverPasswordIdLiterals.componentdesc'),
  choice: { slot1: t('getPRecoverPasswordIdLiterals.choice.slot1'), slot2: t('getPRecoverPasswordIdLiterals.choice.slot2'), slot3: t('getPRecoverPasswordIdLiterals.choice.slot3') },
  input: { maintext: t('getPRecoverPasswordIdLiterals.input.maintext') },
  subinputtext: {
    maintext: t('getPRecoverPasswordIdLiterals.subinputtext.maintext'),
    linktext: t('getPRecoverPasswordIdLiterals.subinputtext.linktext'),
  },
  button: t('getPRecoverPasswordIdLiterals.button'),
  dni:{
    comptitle:t('getPRecoverPasswordIdLiterals.dni.comptitle'),
    compdesc:t('getPRecoverPasswordIdLiterals.dni.compdesc'),
    errorinput:t('getPRecoverPasswordIdLiterals.dni.errorinput'),
  },
  nie:{
    comptitle:t('getPRecoverPasswordIdLiterals.nie.comptitle'),
    compdesc:t('getPRecoverPasswordIdLiterals.nie.compdesc'),
    errorinput:t('getPRecoverPasswordIdLiterals.nie.errorinput'),
  },
  passport:{
    comptitle:t('getPRecoverPasswordIdLiterals.passport.comptitle'),
    compdesc:t('getPRecoverPasswordIdLiterals.passport.compdesc'),
    errorinput:t('getPRecoverPasswordIdLiterals.passport.errorinput'),
  },
}
}

export function getPassValidationLiterals(t: any) {
return{
  title: t('getPassValidationLiterals.title'),
  desc: t('getPassValidationLiterals.desc'),
  passval: {
    chars: t('getPassValidationLiterals.passval.chars'),
    upper: t('getPassValidationLiterals.passval.upper'),
    lower: t('getPassValidationLiterals.passval.lower'),
    number:  t('getPassValidationLiterals.passval.number'),
    special: t('getPassValidationLiterals.passval.special'),
    message: { maintext:t('getPassValidationLiterals.passval.message.maintext'), },
    input: { maintext: { maintext: t('getPassValidationLiterals.passval.input.maintext.maintext'), } },
  },
  button:t('getPassValidationLiterals.button'),
}
}


export function getConfirmRegisterLiterals(t: any) {
  return{
    title: t('getConfirmRegisterLiterals.title'),
    title2: t('getConfirmRegisterLiterals.title2'),
    desc: t('getConfirmRegisterLiterals.desc'),
    button:t('getConfirmRegisterLiterals.button'),
  }
  }
